import { LOGIN_MARKETSMITHINDIA, CHECK_USER_EXISTS, REGISTER_USER, SUCCESSFULL_REGISTRATION, FIREBASE_CREATE_USER } from '@/store/actions.type';
import { mapActions } from "vuex";

export default {
    data () {
        return {
            email: "",
            password: null,
            marketsmithloading: true
        };
    },
    created () {

    },
    methods: {
        ...mapActions({
            loginmarketsmithindia: LOGIN_MARKETSMITHINDIA,
            checkuserexists: CHECK_USER_EXISTS,
            registeruser: REGISTER_USER,
            postregistration: SUCCESSFULL_REGISTRATION,
            firebasecreateuser: FIREBASE_CREATE_USER
        }),

        validateUser () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.msLogin()
                }

            });
        },

        async msLogin () {
            var self = this;
            this.marketsmithloading = false;
            var userObj = {};
            userObj.providerId = 2;
            userObj.email = this.email;
            userObj.password = this.password;
            this.loginmarketsmithindia(userObj).then(result => {
                if (result.data.response.success) {
                    userObj.providerUserId = result.data.response.user.memberid;
                    userObj.phoneNumber = self.processPhoneNumber(result.data.response.user.mobile);
                    userObj.name = result.data.response.user.name;
                    self.checkuserexists(userObj).then(data => {
                        if (!data.response.success) {
                            userObj.refferal = "";
                            userObj.deviceId = 1;
                            userObj.emailConfirmed = true;
                            userObj.phoneNumberConfirmed = true;
                            self.userregistration(userObj);
                        } else {
                            if (localStorage.getItem('redirectpath')) {
                                self.$router.push(localStorage.getItem('redirectpath'));
                                localStorage.removeItem("redirectpath");
                            } else {
                                self.$router.replace('/dashboard');
                                // self.$router.push("/evaluation/")
                                // window.location.reload();
                            }
                        }
                    })
                } else {
                    this.$notify({
                        group: 'allAlerts',
                        title: '',
                        type: 'error',
                        text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">' + result.data.response.message + ' </span></div>'
                    });


                }
                this.marketsmithloading = true;
            })

        },
        processPhoneNumber (number) {
            if (number != null && number.length >= 10) {
                number = number.trim();
                if (number.length == 12) {
                    number = "+" + number;
                    return number;
                }
                else {
                    if (number.length == 10) {
                        number = "+91" + number;
                        return number;
                    }
                }

            } else {
                var postEntry = '0';
                var noOfZeroes = 10 - number.length;
                for (var i = 0; i < noOfZeroes - 1; i++) {
                    postEntry = postEntry + '0';
                }
                return "91" + number + postEntry;
            }
        },
        async userregistration (userObj) {
			var self = this;
            await this.registeruser(userObj).then(result => {
                if (result.data.response.success && result.data.response.token != "") {
                    this.postregistration(result.data.response).then(data => {
                        this.firebasecreateuser(userObj).then(success => {
                            if (success) {
                                this.$notify({
                                    group: 'allAlerts',
                                    title: '',
                                    type: 'success',
                                    text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-success fa fa-check-circle" aria-hidden="true"></i></span> <span class="notificationText">Registered SuccessFully </span></div>'
                                });
                                window.localStorage.setItem('signupMethod', 'MarketSmith');

								if (window.localStorage.getItem('redirectpath')) {
									self.$router.push(window.localStorage.getItem('redirectpath'));
									window.localStorage.removeItem("redirectpath");
								} else {
									this.$router.push("/dashboard");
								}
                            }
                            else {
                                this.$notify({
                                    group: 'allAlerts',
                                    title: '',
                                    type: 'error',
                                    text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">User Registration Failed, Pelase try again! </span></div>'
                                });
                            }
                        });
                    });
                } else {
                    this.$notify({
                        group: 'allAlerts',
                        title: '',
                        type: 'error',
                        text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">' + result.data.response.message + ' </span></div>'
                    });
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/marketsmithindia.js